import styled from "styled-components";

export const StyledSingleMarkerContainer = styled.div`
  transform: "translate(-50%,-100%)";
`;
